import React from 'react';
import { SectionReveal } from './SectionReveal';
export function FinalCtaSection() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 md:py-32 bg-[#0a0a0a]" data-id="element-71">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center" data-id="element-72">
        <SectionReveal data-id="element-73">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-74">
            Entender tu auto puede{' '}
            <span className="text-[#F59E0B]" data-id="element-75">ahorrarte miles de pesos.</span>
          </h2>

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-base font-medium text-[#F5F5F5] mb-10 max-w-3xl mx-auto" data-id="element-76">
            <span data-id="element-77">Tomá decisiones con más confianza.</span>
            <span className="hidden md:inline text-[#F59E0B]" data-id="element-78">•</span>
            <span data-id="element-79">Evitá errores costosos.</span>
            <span className="hidden md:inline text-[#F59E0B]" data-id="element-80">•</span>
            <span data-id="element-81">Preparate para emergencias.</span>
            <span className="hidden md:inline text-[#F59E0B]" data-id="element-82">•</span>
            <span data-id="element-83">Comprá usados con más seguridad.</span>
          </div>

          <p className="text-xl text-[#9CA3AF] mb-10" data-id="element-84">Empezá hoy mismo.</p>

          <button onClick={scrollToOffer} className="w-full sm:w-auto bg-[#F59E0B] hover:bg-[#D97706] text-[#0a0a0a] font-heading font-bold text-xl px-10 py-5 rounded-sm tracking-wider transition-all hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)]" data-id="element-85">
            🚀 QUIERO EL MEGAPACK AHORA
          </button>
        </SectionReveal>
      </div>
    </section>;
}